<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                           <h4>Email</h4>
                                            <form role="form" v-on:submit.prevent="sendMessage" class="mt-4">
                                                <label>Recipients:</label>
                                                <br>
                                                <div class="search-box">
                                                    <input type="text" class="form-control" name="search" placeholder="Search applicants by name or email." v-on:input="searchApplicants" v-model="applicant_filter" />
                                                </div>
                                                <div class="checkbox-fade fade-in-primary">
                                                    <label>
                                                        <input type="checkbox" @change="checkAll($event)" v-model="allChecked">
                                                        <span class="cr">
                                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                                        </span>
                                                        Select All
                                                    </label>
                                                </div>
                                                <div class="form-group select-list" v-if="applicant_filter.length < 1">
                                                    <div class="single-contact included" v-for="applicant in applicants" v-if="message.recipient_mail.includes(applicant.emailaddress)">
                                                        <span class="cancel-icon" title="Remove contact from current mail list." v-on:click="removeFromMailList(applicant.emailaddress)">
                                                            <i class="icofont icofont-close"></i>
                                                        </span>
                                                        {{applicant.firstname + ' ' + applicant.lastname}} ({{applicant.emailaddress}})
                                                    </div>
                                                </div>
                                                <div class="form-group select-list" v-else>
                                                    <div class="single-contact included" v-for="applicant in applicants" v-if="message.recipient_mail.includes(applicant.emailaddress)">
                                                        <span class="cancel-icon" title="Remove contact from current mail list." v-on:click="removeFromMailList(applicant.emailaddress)">
                                                            <i class="icofont icofont-close"></i>
                                                        </span>
                                                        {{applicant.firstname + ' ' + applicant.lastname}} ({{applicant.emailaddress}})
                                                    </div>
                                                    <div class="single-contact not-included" v-else>
                                                        <span class="plus-icon" title="Add contact to current mail list." v-on:click="message.recipient_mail.push(applicant.emailaddress)">
                                                            <i class="icofont icofont-plus"></i>
                                                        </span>
                                                        {{applicant.firstname + ' ' + applicant.lastname}} ({{applicant.emailaddress}})
                                                    </div>
                                                </div>
                                                <!-- <span class="recipient_count">{{ message.recipient_mail.length }}</span> -->
                                                <div class="form-group">
                                                    <label>Title:</label>
                                                    <input type="text" class="form-control" v-model="message.email_title" name="title" placeholder="Email Title" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Message:</label>
                                                    <summernote height="400" :model.sync="message.email_body"></summernote>
                                                </div>
                                                <div class="form-group">
                                                    <input type="submit" name="submit" class="btn btn-primary" />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .select-list{
        max-height: 200px; 
        overflow-y: auto;
        border: 1px solid #ddd;
        padding: 10px;
        border-radius: 2px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    }
    .selet-list::-webkit-scrollbar {
        width: 4px;
        background-color: #F5F5F5;
    }
    .selet-list::-webkit-scrollbar-thumb {
        background-color: #000000;
    }
    .h-100{
        height: 100px !important;
    }
    .select-all{
        padding-left: 10px;
    }
    .select-all-check::before{
        margin-left: 10px !important;
    }
    .select-all-check::after{
        margin-left: 10px !important;
    }
    .single-contact{
        padding: 5px 7px 4px 10px;
        border-radius: 30px;
        margin-top: 5px;
        display: inline-flex;
        margin-left: 5px;
        margin-right: 5px;
    }
    .included{
        background: #bacff091;
        border: 1px solid #bad2f7;
    }
    .not-included{
        background: #ffd5d59c;
        border: 1px solid #f4b3b3;
    }
    .single-contact span{
        padding-right: 3px;
    }
    .search-box{
        margin-bottom: 10px !important;
    }
    .cancel-icon, .plus-icon{
        cursor: pointer;
    }
    .cancel-icon i{
        color: #e62020;
    }
    .plus-icon i{
        color: #1adc33;
    }
</style>
<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import summernote from '../components/Summernote'

function initialValue(){
    return{
        recipient_mail: [],
        email_body: "",
        email_title: ""

    }
}

export default {
    name: 'Email',

    data(){
        return{
            applicants: [],
            applicants_copy: [],
            allChecked: false,
            message: initialValue(),
            applicant_filter: ""
        }
    },

    components:{
        navbar1,
        navbar2,
        summernote
    },

    mounted(){
        this.getApplicants()
    },
    methods: {
        setAll () {
            if(query.toLowerCase == 'all'){

            }
            this.message.recipient_mail.push(this.applicants[i].emailaddress)
        },
        checkAll: function(checked){
            // console.log(checked)
            if(this.allChecked){
                for(var i = 0; i < this.applicants.length; i++){
                    this.message.recipient_mail.push(this.applicants[i].emailaddress)
                }
            } else {
                this.message.recipient_mail = []
                // this.allChecked = false
            }
            
        },

        watchCheck: function(){
            //I think there's a better way to do this with Vue watcher
            //just not sure how
            if(this.message.recipient_mail.length < this.applicants.length){
                this.allChecked = false
            } else {
                this.allChecked = true
            }
        },

        getApplicants(){
            var applicants = {
                what: 'getApplicantEmail'
            }

            this.$socket.makeGetRequest(applicants)
                .then((response)=>{
                    if(response.type == 'getApplicantEmail'){
                        let data = response.data
                        //this.applicants = data

                        var data_length = data.length

                        //Filter out duplicate emails by checking if the email already exists
                        //in the array before pushing it in
                        for(var i=0; i<data.length; i++){
                            // if(!this.message.recipient_mail.includes(data[i].emailaddress)){
                            //     this.message.recipient_mail.push(data[i].emailaddress)
                                this.applicants.push(data[i])
                            // }
                        }

                        this.applicants_copy = this.applicants
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        },

        sendMessage(){

            var send_email = {
                what: 'SendEmail',
                data: this.message
            }

            if(this.message.recipient_mail.length > 0){
                this.$socket.makePostRequest(send_email)
                    .then((response)=>{
                        if(response.type == "SendEmail"){
                            this.$swal.fire("Success", "Email sent to recipients.", 'success')

                            setTimeout(()=>{
                                window.location.reload()
                            }, 1000)
                        }
                    })
                    .catch((error)=>{
                        console.log(error)

                    })
                } else {
                    this.$swal.fire('Please select a recipient.', '', 'error')
                }
                
        },

        removeFromMailList: function(applicant_email){
            var applicant_index = this.message.recipient_mail.findIndex(mail => mail == applicant_email)
            this.message.recipient_mail.splice(applicant_index, 1)
        },

        searchApplicants: function(){
            //var current_applicants = this.applicants_copy
            var query = this.applicant_filter
            

            if(query.length > 0){
                this.applicants = this.applicants_copy.filter((x) => {
                   return (x.emailaddress.indexOf(query) !== -1) //&& (x.firstname.indexOf(query) !== -1) && (x.lastname.indexOf(query) !== -1)
                })
            } else {
                this.applicants = this.applicants_copy
            }
            
        }

    },
    computed: {
        
    }
}
</script>
